// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.titleBar-root {
  background: var(--appcontent-bg-layer-color);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;

  padding: 0px 43px 20px 10px;
  font-family: var(--subHeading-FontName);
  font-style: normal;
  font-weight: var(--subHeading-FontWeight);
  font-size: var(--subHeading-FontSize);
  line-height: 1.75rem;
  color: var(--TitleBar-TextColour);

  white-space: nowrap;
}

.titleBar-root.nonnps {
  height: 70px;
  padding: 0 16px;
  background-color: var(--whiteColour);
}

.titleBar-root.removeLeftPadding {
  padding-left: 0px;
}

.titleBar-Search {
  width: 100%;
}

.titleBar-Search.Searchdisabled {
  pointer-events: none;
}

.titleBar-icon {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: end;
  align-items: center;
  gap: 30px;
  max-width: 70%;
}

.titleBar-iconList {
  text-align: center;
  color: var(--TitleBar-IconColour);
  margin-left: 32px;
}

.notificationDiv {
  position: relative;
}

.titleBar-root .titleBarUser-avatar {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  gap: 10px;
}

.titleBar-root .titleBarUser-avatar .titleBarUser-info {
  visibility: visible;
  background-color: #ffffff;
  color: #000000;
  border-radius: 6px;
  top: 100%;
  position: absolute;
  padding: 0.5rem;
  font-family: var(--label-FontName);
  font-style: normal;
  line-height: 21px;
  z-index: 5;
  right: -15px;
  width: 227px;
  font-weight: 400;
  font-size: var(--default-FontSize);
  height: 115px;
  padding: 0px;
  border: 1px solid #eeeeee;
}

.titleBarUser-info {
  font-size: var(--brandTitle);
}

.mainDivTitleBar {
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  align-items: center;
  align-content: center;
  margin-left: -47px;
}

.subTitlebar {
  display: flex;
  flex-flow: column;
}

.subTitleName {
  padding: 15px 15px;
  font-family: var(--label-FontName);
}

.avataricon
  .MuiAvatar-root
  .MuiAvatar-circle
  .avataricon__avatar-image
  .MuiAvatar-colorDefault {
  height: 1.88rem;
}

.innerDiv {
  padding: 0px 0px 0px 5px;
  align-self: center;
  font-family: var(--label-FontName);
  font-size: var(--default-FontSize);
}

.avataricon .MuiAvatar-root.L-Avatar {
  height: 80px;
  width: 80px;
  font-size: var(--avatarFontSize);
}

.avataricon .MuiAvatar-root.Main-Avatar {
  width: 38px;
  height: 38px;
  background: #1f3c88;

  font-family: var(--label-FontName);
  font-style: normal;
  font-weight: var(--header-FontWeight);
  font-size: var(--sub-header-FontSize);
  line-height: 12px;
  color: #ffffff;
}

.usernamesection {
  overflow: hidden;
  text-overflow: ellipsis;
  color: #46556c;
  font-size: var(--mainheading-FontSize);
  font-weight: 700;
  font-family: var(--label-FontName);
  font-style: normal;
  line-height: 38px;
}

.notify-circle {
  width: 12px;
  background-color: #ffc107;
  border-radius: 50%;
  text-align: center;
  z-index: 150;
  position: absolute;
  font-size: 14px;
  height: 12px;
  margin-top: -58%;
  margin-left: 87%;
  line-height: 15.3px;
  color: #5a5a5a;
  font-family: var(--label-FontName);
  font-weight: var(--header-FontWeight);
}

.count {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--header-FontWeight);
  font-size: 10px;
  line-height: 13px;
  color: #5a5a5a;
  text-align: center;
}

.messages .notifyHeader {
  position: relative;
  width: 102%;
  height: 57px;
  left: 20px;
  top: 0px;
  font-family: var(--label-FontName);
  font-style: normal;
  font-weight: var(--header-FontWeight);
  font-size: var(--additionalTabSideHead);
  position: sticky;
  line-height: 1.25vw;
  background-color: white;
  z-index: 1000;
  padding-top: 4%;
  padding-left: 4.5%;
}

.totalDetails:hover {
  background: #eef3ff;
}

.totalDetails {
  box-sizing: border-box;
  position: relative;
  width: 423px;
  height: 105px;
  top: 0px;
  border-bottom: 1px solid #e9e9e9;
}

.notifycaseNumber {
  position: absolute;
  width: 94px;
  height: 21px;
  left: 21px;
  top: 67px;

  font-family: var(--label-FontName);
  font-style: normal;
  font-weight: 400;
  font-size: var(--default-FontSize);
  line-height: 1.094vw;

  /* Neautral/Jet/80 */

  color: #838383;
}

.notifyDate {
  position: relative;
  width: 98px;
  height: 19px;
  left: 308px;
  top: 67px;

  font-family: var(--label-FontName);
  font-style: italic;
  font-weight: 350;
  font-size: var(--brandTitle);
  line-height: var(--brandTitle);
  /* identical to box height */

  /* Border-Grey */

  color: #b6b6b6;
}

.subnotifyHeader {
  position: absolute;
  width: 14.271vw;
  height: 42px;
  left: 21px;
  top: 10px;
  font-family: var(--label-FontName);
  font-style: normal;
  font-weight: 400;
  font-size: var(--default-FontSize);
  line-height: 1.094vw;
  color: #333333;
  text-overflow: ellipsis;
  overflow: hidden;
  /* // Addition lines for 2 line or multiline ellipsis */
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.messages {
  background-color: white;
  color: var(--default-FontColour);
  border-radius: 6px;
  top: 100%;
  position: absolute;
  font-family: var(--label-FontName);
  font-style: normal;
  line-height: 20px;
  z-index: 5;
  right: -15px;
  box-sizing: border-box;
  width: 28.438rem;
  height: 36.5rem;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.darkCircle {
  position: absolute;
  width: 12px;
  height: 12px;
  left: 394px;
  top: 19px;
  border-radius: 50%;
  /* Freeflow Backoffice - primary */

  background: #1f3c88;
}

.titleBar-root .userHeader {
  display: flex;
  justify-content: flex-end;
}

.titleBarUser {
  margin: 10px;
  border-width: 8px;
  top: 3px;
  margin-top: 10px;
}

.titleBarUserDropDown {
  margin-top: 2%;

  border-width: 8px;
}

.messages:out-of-range {
  z-index: 0;
}

.titleBar-title {
  width: fit-content;
  padding: 7px 0px;
}

.titleBar-title.companyLogoDiv {
  width: 90px;
  padding: 7px 7.85px;
  border-radius: 0px 5.159vh 5.159vh 0px;
  /* responsive css */
  /*   width: 5.364vw;
  height: 5.779vh;
  padding: 1.135vh 0.877vw;
  border-radius: 0px 5.159vh 5.159vh 0px; */
  display: flex;
  justify-content: end;
  background-color: var(--appcontent-bg-color);
  cursor: pointer;
}

.titleBar-root .titleBarUser-avatar {
  display: grid;
  grid-template-columns: auto minmax(50px, 1fr) auto;
}

.titleBar-root .titleBarUserDropDown {
  cursor: pointer;
}

.titleBar-root .avataricon,
.titleBar-root .titleBarUser-avatar {
  cursor: default;
}

.titleBar-root .titleBarPage-logout {
  cursor: pointer;
  display: flex;
  padding: 8px 0px 0px 0px;
}

@media screen and (min-width: 1150px) and (max-width: 1500px) {
  /*  .titleBar-root {
    height: 100px;
  } */
  /* commented for reference */
  .titleBarUserDropDown {
    height: 7px;
    width: 14px;
  }

  .avataricon .MuiAvatar-root.Main-Avatar {
    width: 34px;
    height: 34px;
  }

  .ui.input {
    height: 36px;
  }
}

@media screen and (min-width: 950px) and (max-width: 1149px) {
  .searchIcon {
    height: 34px;
  }

  .titleBarUserDropDown {
    margin-top: 2px;
    height: 7px;
    width: 12px;
  }

  /*  .titleBar-root {
    height: 100px;
  } */
  /* commented for reference */

  .titleBar-iconList {
    height: 16px;
    width: 17px;
  }

  .ui.input {
    height: 34px;
  }

  .ui.input > input::placeholder {
    font-size: var(--additionalTabSideHead);
  }
}

.titleBar-root .titleBarUserDropDownDiv {
  margin-top: 50%;
  height: 100%;
  cursor: pointer;
}

#userDropDownMenu .MuiPaper-root {
  padding: 8px 0px;
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
}

#userDropDownMenu .MuiPaper-root ul {
  width: inherit;
  display: flex;
  flex-direction: column;
  padding: 0px;
}

#userDropDownMenu .MuiPaper-root ul li {
  display: flex;
  flex-direction: row;
  padding: 6px 16px;
  justify-content: flex-start;
}

#dialog_dataLogOutWarning .MuiDialogTitle-root .MuiTypography-root {
  font-size: var(--dialogTitleFontSize);
  font-family: var(--default-FontName);
  color: var(--default-FontColour);
  font-weight: var(--dialogTitleFontWeight);
}

#dialog_dataLogOutWarning .MuiDialogTitle-root {
  padding: 0px;
}

#userDropDownMenu li .innerDiv {
  letter-spacing: normal;
}

#dialog_dataLogOutWarning .logoutString {
  gap: 7px;
  display: grid;
  color: var(--default-FontColour);
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/titleBar/TitleBar.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,4CAA4C;EAC5C,aAAa;EACb,kCAAkC;EAClC,mBAAmB;;EAEnB,2BAA2B;EAC3B,uCAAuC;EACvC,kBAAkB;EAClB,yCAAyC;EACzC,qCAAqC;EACrC,oBAAoB;EACpB,iCAAiC;;EAEjC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,kCAAkC;EAClC,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,kCAAkC;EAClC,kBAAkB;EAClB,qCAAqC;EACrC,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;;EAET,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;;EAEpB,oBAAoB;;EAEpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;;EAET,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;;EAE5B,gBAAgB;;EAEhB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,uDAAuD;EACvD,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,kCAAkC;;EAElC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB;;;2CAGyC;EACzC,aAAa;EACb,oBAAoB;EACpB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE;;KAEG;EACH,4BAA4B;EAC5B;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,WAAW;EACb;;EAEA;;KAEG;EACH,4BAA4B;;EAE5B;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,gCAAgC;AAClC","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.titleBar-root {\n  background: var(--appcontent-bg-layer-color);\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  align-items: center;\n\n  padding: 0px 43px 20px 10px;\n  font-family: var(--subHeading-FontName);\n  font-style: normal;\n  font-weight: var(--subHeading-FontWeight);\n  font-size: var(--subHeading-FontSize);\n  line-height: 1.75rem;\n  color: var(--TitleBar-TextColour);\n\n  white-space: nowrap;\n}\n\n.titleBar-root.nonnps {\n  height: 70px;\n  padding: 0 16px;\n  background-color: var(--whiteColour);\n}\n\n.titleBar-root.removeLeftPadding {\n  padding-left: 0px;\n}\n\n.titleBar-Search {\n  width: 100%;\n}\n\n.titleBar-Search.Searchdisabled {\n  pointer-events: none;\n}\n\n.titleBar-icon {\n  display: grid;\n  grid-template-columns: auto auto;\n  justify-content: end;\n  align-items: center;\n  gap: 30px;\n  max-width: 70%;\n}\n\n.titleBar-iconList {\n  text-align: center;\n  color: var(--TitleBar-IconColour);\n  margin-left: 32px;\n}\n\n.notificationDiv {\n  position: relative;\n}\n\n.titleBar-root .titleBarUser-avatar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  gap: 10px;\n}\n\n.titleBar-root .titleBarUser-avatar .titleBarUser-info {\n  visibility: visible;\n  background-color: #ffffff;\n  color: #000000;\n  border-radius: 6px;\n  top: 100%;\n  position: absolute;\n  padding: 0.5rem;\n  font-family: var(--label-FontName);\n  font-style: normal;\n  line-height: 21px;\n  z-index: 5;\n  right: -15px;\n  width: 227px;\n  font-weight: 400;\n  font-size: var(--default-FontSize);\n  height: 115px;\n  padding: 0px;\n  border: 1px solid #eeeeee;\n}\n\n.titleBarUser-info {\n  font-size: var(--brandTitle);\n}\n\n.mainDivTitleBar {\n  display: flex;\n  flex-flow: row;\n  justify-content: space-around;\n  align-items: center;\n  align-content: center;\n  margin-left: -47px;\n}\n\n.subTitlebar {\n  display: flex;\n  flex-flow: column;\n}\n\n.subTitleName {\n  padding: 15px 15px;\n  font-family: var(--label-FontName);\n}\n\n.avataricon\n  .MuiAvatar-root\n  .MuiAvatar-circle\n  .avataricon__avatar-image\n  .MuiAvatar-colorDefault {\n  height: 1.88rem;\n}\n\n.innerDiv {\n  padding: 0px 0px 0px 5px;\n  align-self: center;\n  font-family: var(--label-FontName);\n  font-size: var(--default-FontSize);\n}\n\n.avataricon .MuiAvatar-root.L-Avatar {\n  height: 80px;\n  width: 80px;\n  font-size: var(--avatarFontSize);\n}\n\n.avataricon .MuiAvatar-root.Main-Avatar {\n  width: 38px;\n  height: 38px;\n  background: #1f3c88;\n\n  font-family: var(--label-FontName);\n  font-style: normal;\n  font-weight: var(--header-FontWeight);\n  font-size: var(--sub-header-FontSize);\n  line-height: 12px;\n  color: #ffffff;\n}\n\n.usernamesection {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #46556c;\n  font-size: var(--mainheading-FontSize);\n  font-weight: 700;\n  font-family: var(--label-FontName);\n  font-style: normal;\n  line-height: 38px;\n}\n\n.notify-circle {\n  width: 12px;\n  background-color: #ffc107;\n  border-radius: 50%;\n  text-align: center;\n  z-index: 150;\n  position: absolute;\n  font-size: 14px;\n  height: 12px;\n  margin-top: -58%;\n  margin-left: 87%;\n  line-height: 15.3px;\n  color: #5a5a5a;\n  font-family: var(--label-FontName);\n  font-weight: var(--header-FontWeight);\n}\n\n.count {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--header-FontWeight);\n  font-size: 10px;\n  line-height: 13px;\n  color: #5a5a5a;\n  text-align: center;\n}\n\n.messages .notifyHeader {\n  position: relative;\n  width: 102%;\n  height: 57px;\n  left: 20px;\n  top: 0px;\n  font-family: var(--label-FontName);\n  font-style: normal;\n  font-weight: var(--header-FontWeight);\n  font-size: var(--additionalTabSideHead);\n  position: sticky;\n  line-height: 1.25vw;\n  background-color: white;\n  z-index: 1000;\n  padding-top: 4%;\n  padding-left: 4.5%;\n}\n\n.totalDetails:hover {\n  background: #eef3ff;\n}\n\n.totalDetails {\n  box-sizing: border-box;\n  position: relative;\n  width: 423px;\n  height: 105px;\n  top: 0px;\n  border-bottom: 1px solid #e9e9e9;\n}\n\n.notifycaseNumber {\n  position: absolute;\n  width: 94px;\n  height: 21px;\n  left: 21px;\n  top: 67px;\n\n  font-family: var(--label-FontName);\n  font-style: normal;\n  font-weight: 400;\n  font-size: var(--default-FontSize);\n  line-height: 1.094vw;\n\n  /* Neautral/Jet/80 */\n\n  color: #838383;\n}\n\n.notifyDate {\n  position: relative;\n  width: 98px;\n  height: 19px;\n  left: 308px;\n  top: 67px;\n\n  font-family: var(--label-FontName);\n  font-style: italic;\n  font-weight: 350;\n  font-size: var(--brandTitle);\n  line-height: var(--brandTitle);\n  /* identical to box height */\n\n  /* Border-Grey */\n\n  color: #b6b6b6;\n}\n\n.subnotifyHeader {\n  position: absolute;\n  width: 14.271vw;\n  height: 42px;\n  left: 21px;\n  top: 10px;\n  font-family: var(--label-FontName);\n  font-style: normal;\n  font-weight: 400;\n  font-size: var(--default-FontSize);\n  line-height: 1.094vw;\n  color: #333333;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  /* // Addition lines for 2 line or multiline ellipsis */\n  display: -webkit-box !important;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  white-space: normal;\n}\n\n.messages {\n  background-color: white;\n  color: var(--default-FontColour);\n  border-radius: 6px;\n  top: 100%;\n  position: absolute;\n  font-family: var(--label-FontName);\n  font-style: normal;\n  line-height: 20px;\n  z-index: 5;\n  right: -15px;\n  box-sizing: border-box;\n  width: 28.438rem;\n  height: 36.5rem;\n  background: #ffffff;\n  border: 1px solid #eeeeee;\n  border-radius: 6px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.darkCircle {\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  left: 394px;\n  top: 19px;\n  border-radius: 50%;\n  /* Freeflow Backoffice - primary */\n\n  background: #1f3c88;\n}\n\n.titleBar-root .userHeader {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.titleBarUser {\n  margin: 10px;\n  border-width: 8px;\n  top: 3px;\n  margin-top: 10px;\n}\n\n.titleBarUserDropDown {\n  margin-top: 2%;\n\n  border-width: 8px;\n}\n\n.messages:out-of-range {\n  z-index: 0;\n}\n\n.titleBar-title {\n  width: fit-content;\n  padding: 7px 0px;\n}\n\n.titleBar-title.companyLogoDiv {\n  width: 90px;\n  padding: 7px 7.85px;\n  border-radius: 0px 5.159vh 5.159vh 0px;\n  /* responsive css */\n  /*   width: 5.364vw;\n  height: 5.779vh;\n  padding: 1.135vh 0.877vw;\n  border-radius: 0px 5.159vh 5.159vh 0px; */\n  display: flex;\n  justify-content: end;\n  background-color: var(--appcontent-bg-color);\n  cursor: pointer;\n}\n\n.titleBar-root .titleBarUser-avatar {\n  display: grid;\n  grid-template-columns: auto minmax(50px, 1fr) auto;\n}\n\n.titleBar-root .titleBarUserDropDown {\n  cursor: pointer;\n}\n\n.titleBar-root .avataricon,\n.titleBar-root .titleBarUser-avatar {\n  cursor: default;\n}\n\n.titleBar-root .titleBarPage-logout {\n  cursor: pointer;\n  display: flex;\n  padding: 8px 0px 0px 0px;\n}\n\n@media screen and (min-width: 1150px) and (max-width: 1500px) {\n  /*  .titleBar-root {\n    height: 100px;\n  } */\n  /* commented for reference */\n  .titleBarUserDropDown {\n    height: 7px;\n    width: 14px;\n  }\n\n  .avataricon .MuiAvatar-root.Main-Avatar {\n    width: 34px;\n    height: 34px;\n  }\n\n  .ui.input {\n    height: 36px;\n  }\n}\n\n@media screen and (min-width: 950px) and (max-width: 1149px) {\n  .searchIcon {\n    height: 34px;\n  }\n\n  .titleBarUserDropDown {\n    margin-top: 2px;\n    height: 7px;\n    width: 12px;\n  }\n\n  /*  .titleBar-root {\n    height: 100px;\n  } */\n  /* commented for reference */\n\n  .titleBar-iconList {\n    height: 16px;\n    width: 17px;\n  }\n\n  .ui.input {\n    height: 34px;\n  }\n\n  .ui.input > input::placeholder {\n    font-size: var(--additionalTabSideHead);\n  }\n}\n\n.titleBar-root .titleBarUserDropDownDiv {\n  margin-top: 50%;\n  height: 100%;\n  cursor: pointer;\n}\n\n#userDropDownMenu .MuiPaper-root {\n  padding: 8px 0px;\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n}\n\n#userDropDownMenu .MuiPaper-root ul {\n  width: inherit;\n  display: flex;\n  flex-direction: column;\n  padding: 0px;\n}\n\n#userDropDownMenu .MuiPaper-root ul li {\n  display: flex;\n  flex-direction: row;\n  padding: 6px 16px;\n  justify-content: flex-start;\n}\n\n#dialog_dataLogOutWarning .MuiDialogTitle-root .MuiTypography-root {\n  font-size: var(--dialogTitleFontSize);\n  font-family: var(--default-FontName);\n  color: var(--default-FontColour);\n  font-weight: var(--dialogTitleFontWeight);\n}\n\n#dialog_dataLogOutWarning .MuiDialogTitle-root {\n  padding: 0px;\n}\n\n#userDropDownMenu li .innerDiv {\n  letter-spacing: normal;\n}\n\n#dialog_dataLogOutWarning .logoutString {\n  gap: 7px;\n  display: grid;\n  color: var(--default-FontColour);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
